import getById from 'utils/DOM/getById'
import toggleClass from 'utils/DOM/toggleClass'

const initForumBanner = (hcStorage, isClic) => {
  const startForumDate = new Date('2024-10-21')
  const endForumDate = new Date('2024-11-04')
  if (
    new Date() >= startForumDate &&
    new Date() <= endForumDate &&
    hcStorage.location.state_acronym === 'IN'
  ) {
    toggleClass('#cro-countdown', 'd-none', false)
    const text = getById('forumText')
    const urlCompanion =
      'https://healthcare.zoom.us/webinar/register/WN_by2qQxZASKSN983xZm5mTA'
    const urlNorth =
      'https://healthcare.zoom.us/webinar/register/WN_TLv7KVT0ReOUIbYrntjxYA'
    const clicText = `The Companion Life Insurance Company announces a public forum review of the 2024 Short Term Medical Pivot Health Plan portfolio on November 4, 2024 at 1:00pm Central time.  The virtual meeting will highlight the 2024 Pivot Health Short Term Medical plan performance, premiums and health care cost efforts.  To register for this event, <a class="font-weight-bold link-forum link-forum--companion" href="${urlCompanion}" target="_blank">click here</a>. Forum attendees may submit questions in advance to: <a class="Header__contact-action Header__contact-action--email d-inline" href="mailto:forum1@healthcare.com">forum1@healthcare.com</a>.`
    const nricText = `The North River Insurance Company announces a public forum review of the 2024 Short Term Medical Pivot Health Plan portfolio on November 4, 2024 at 2:00pm Central time.  The virtual meeting will highlight the 2024 Pivot Health Short Term Medical plan performance, premiums and health care cost efforts.  To register for this event, <a class="font-weight-bold link-forum link-forum--companion" href="${urlNorth}" target="_blank">click here</a>. Forum attendees may submit questions in advance to: <a class="Header__contact-action Header__contact-action--email d-inline" href="mailto:forum2@healthcare.com">forum2@healthcare.com</a>.`
    if (text) text.innerHTML = isClic ? clicText : nricText
  }
}

export default initForumBanner
